import { useQuery } from '@tanstack/react-query';
import cacheQueryKeys from 'resources/ReactQuery/queryCacheKeys';

import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

import { getSearchResultsFilter } from '../../Utils';
import { SearchResult } from '../types';

import GlobalSearchApi from './Api';

export const useGlobalSearch = ({ searchTerm }: { searchTerm: string }) => {
  const { trackSearchPerformed } = useTrackEventsService();

  const handleTrackingSearchPerformed = (results: SearchResult[]) => {
    const { jobs, estimates, customers, equipment } = getSearchResultsFilter(results);
    const numberResults = {
      jobs_results_count: jobs.length,
      estimates_results_count: estimates.length,
      customers_results_count: customers.length,
      equipment_results_count: equipment.length,
    };

    trackSearchPerformed({ searchTerm, source: 'navigation', ...numberResults });
  };

  return useQuery({
    queryKey: [cacheQueryKeys.GlobalSearch, searchTerm],
    keepPreviousData: true,
    queryFn: () => GlobalSearchApi.getSearchResults(searchTerm),
    select: (response) => response.data.data,
    onSuccess: (data) => {
      handleTrackingSearchPerformed(data as SearchResult[]);
    },
    enabled: searchTerm.length > 0,
  });
};
